module.exports = __webpack_public_path__ + "static/ss5-22dc1164fbefd6113393551677e0b724.png";